import { ChangeDetectorRef, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ResizeService } from 'src/app/services/resize.service';
import { TranslationService } from 'src/app/i18n/translation.service';
import { MultimediaService } from 'src/app/services/apis/multimedia.service';
import { isPlatformBrowser } from '@angular/common';
import { SharedService } from 'src/app/services/shared.service';
import { NavigationEnd, Router } from '@angular/router';
import { catchError, forkJoin, of, Subscription } from 'rxjs';
import { logMessage } from 'src/app/helpers/logs';
import { RouteLocalizationPipe } from 'src/app/pipes/route-localization.pipe';
const maximumWidth = 1440;

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit {
  isDataReady: boolean = false;
  @Input() pageType: string = "";
  isNotificationEnabled: boolean = true;
  isChatEnabled: boolean = true;
  isSubSitesEnabled: boolean = true;
  isRTL: boolean = this.TranslationService.isRTL();
  margin: number = 0;

  chatWidget: any = {
    // isEnabled: true,
    content: 'chat',
    title: {
      en: '',
      ar: ''
    },
    link: '/second-page/',
    backgroundColor: 'bg-[#D1A755]',
    hoverClass: 'chat-container',
    // 
    icon: '',//assets/svgs/chat.svg
    width: 32,
    heigh: 32,
    // 
    polygonColor: '#ECD9AE',
    animation: 'animate-[fadeInUp_0.6s_1.45s_ease_both]',
    notification: false
  };

  notificationWidget: any = {
    // isEnabled: true,
    content: 'notification',
    title: {
      en: '',
      ar: ''
    },
    link: '',
    // backgroundColor: 'bg-[#3E64FF]',
    backgroundColor: 'bg-[#D1A755]',
    // hoverClass: 'notification-container',
    hoverClass: 'chat-container',
    // 
    icon: '',//assets/svgs/notification.svg
    width: 40,
    heigh: 40,
    // 
    polygonColor: '#D1A755',
    // polygonColor: '#174E91',
    animation: 'animate-[fadeInUp_0.6s_1.8s_ease_both]',
    notification: 2
  };

  starWidget: any = {
    // isEnabled: true,
    isDataShown: false,
    icon: '',
    list: []
  };


  isMouseOver: any = {
    notification: false,
    star: false,
    chat: false
  };
  private routerEventsSubscription: Subscription;

  constructor(
    private resizeService: ResizeService,
    private cdk: ChangeDetectorRef,
    private TranslationService: TranslationService,
    private multimediaService: MultimediaService,
    private sharedService: SharedService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private routeLocalizationPipe: RouteLocalizationPipe,    
  ) {
    this.getData();
    this.routerEventsSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getData();
      }
    });
  }

  ngOnDestroy() {
    // Unsubscribe from router events to prevent memory leaks
    this.routerEventsSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.enableMaximumWidthFeature();
  }

  getData() {
    this.isRTL = this.TranslationService.isRTL();
    // Set link based on language
  this.notificationWidget.link = this.isRTL
    ? 'https://kenar.woqod.com/web/ar/'
    : 'https://kenar.woqod.com/web/en/';
    this.isDataReady = false;
    forkJoin({
      getStickyIcons: this.multimediaService.getStickyIcons().pipe(catchError(err => of(null))),
      getSubSitesList: this.multimediaService.getSubSitesList().pipe(catchError(err => of(null))),
    }).subscribe({
      next: (results) => {
        logMessage('Widget Response ', results);
        if (results.getStickyIcons) this.getStickyIcons(results.getStickyIcons);
        if (results.getSubSitesList) this.getSubSitesList(results.getSubSitesList);
        this.isDataReady = true;
      },
      error: (err) => {
        logMessage('Widget Unexpected error in forkJoin:', err);
      }
    });
  }

  enableMaximumWidthFeature() {
    this.setMaximumWidth(this.resizeService.getWindowWidth());
    this.resizeService.screenWidth$.subscribe(screenWidth => this.setMaximumWidth(screenWidth));
  }

  setMaximumWidth(screenWidth: any) {
    this.margin = screenWidth > maximumWidth ? (screenWidth - maximumWidth) / 2 : 0;
    // 
    this.closeWidget();
  }

  closeWidget() {
    for (const key in this.isMouseOver) {
      if (this.isMouseOver[key]) this.setAnimationClass(key, false);
    }
  }

  mouseout(option: string, event: MouseEvent) {
    event.stopPropagation();
    this.setAnimationClass(option, false);
  }

  mouseover(option: string, event: MouseEvent) {
    event.stopPropagation();
    this.setAnimationClass(option, true);
  }

  setAnimationClass(option: string, isMouseOverEnabled: boolean) {
    if (this.isMouseOver[option] !== isMouseOverEnabled) this.isMouseOver[option] = isMouseOverEnabled;
    if (!this.starWidget.isDataShown && option === "star" && isMouseOverEnabled) this.starWidget.isDataShown = true;
    this.cdk.detectChanges();
  }

  getStickyIcons(response: any) {
    const isUsreLoggedIn = isPlatformBrowser(this.platformId) ? !!localStorage.getItem('token') : '';//is user logged in
    this.isChatEnabled = response.showChatBotIcon;
    this.chatWidget.title = {
      en: response.chatBotTitleEN,
      ar: response.chatBotTitleAR
    };
    this.chatWidget.icon = response.chatBotIconImage;
    // 
    this.isNotificationEnabled = response.showNotificationsIcon;
    this.notificationWidget.title = {
      en: response.notificationsTitleEN,
      ar: response.notificationsTitleAR
    };
    this.notificationWidget.icon = response.notificationsIconImage;
    // 
    this.isSubSitesEnabled = response.showSubsitesIcon;
    // this.starWidget.title = {//not in use
    //   en: response.chatBotTitleEN,
    //   ar: response.chatBotTitleAR
    // };
    this.starWidget.icon = response.subsitesIconImage;
  }

  getSubSitesList(response: any) {
    const responseArray = Array.isArray(response) ? response : [response];
    let originalArray = responseArray.filter((item: any) => item.showSubsite).map((item: any) => {
      return {
        src: item.subsiteIconImageID,
        width: "81",
        height: "24",
        alt: item.subsiteTitleEN,
        title: item.subsiteTitleEN,
        link: item.subsiteURL
        // link: item.subsiteURL
      }
    });

    // originalArray = [...originalArray, ...originalArray, ...originalArray, ...originalArray, ...originalArray, ...originalArray, ...originalArray, ...originalArray,]


    // Initialize two empty arrays
    const firstArray = [];
    const secondArray = [];

    // Loop through the original array
    for (let i = 0; i < originalArray.length; i++) {
      // Check if the current index is even or odd
      if (i % 2 === 0) {
        // Even index, push to the first array
        firstArray.push(originalArray[i]);
      } else {
        // Odd index, push to the second array
        secondArray.push(originalArray[i]);
      }
    }
    this.starWidget.list = [firstArray.splice(0, 3), secondArray.splice(0, 3)];
  }

  fireEvent(fireType: string = '', link: string) {
    if (fireType === 'chat' && typeof window !== 'undefined') {
      let verloopBtn: any = document.querySelector(".verloop-button");
      if (verloopBtn) verloopBtn.click();
    }else if (fireType === 'notification' && typeof window !== 'undefined'){
      window.open(this.routeLocalizationPipe.transform(link),'_blank');
    }
  }
  isExternalMethod(link: string) {
    return this.sharedService.isExternalMethod(link);
  }
}
